import React from 'react';
import { Helmet } from 'react-helmet';
import addressFormatter from './transformers/address';
import { LocationPropType } from '../../../services/proptypes';

// @deprecated. Prefer using LocalBusinessSchema
var FoodEstablishmentSchema = function FoodEstablishmentSchema(_ref) {
  var siteUrl = _ref.siteUrl,
    images = _ref.images,
    businessType = _ref.businessType,
    businessSubtypes = _ref.businessSubtypes,
    name = _ref.name,
    logo = _ref.logo,
    address = _ref.address;
  var isRestaurant = businessType === 'restaurant';
  var featuredImage = images && images.length && images.length > 0 ? images[0] : null;
  var data = {
    '@context': 'https://schema.org',
    '@type': isRestaurant ? 'Restaurant' : 'FoodEstablishment',
    name: name,
    url: siteUrl,
    logo: logo,
    address: addressFormatter(address),
    servesCuisine: businessSubtypes
  };
  if (featuredImage) {
    data.image = featuredImage;
  }
  return /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)));
};
export default FoodEstablishmentSchema;
FoodEstablishmentSchema.defaultProps = {
  siteUrl: null,
  images: [],
  businessSubtypes: [],
  logo: '',
  address: ''
  // menu: '',
};